
import React, { useEffect, useState } from "react";
import { Container, Table, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";

export default function AloMappedReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const Data = location?.state?.data;
  const [MappedMandals, setMappedMandals] = useState([]);
  function MandalsMappedData() {
    const url = config.url.BOC_URL + "districtwisedashboard/mandalcompleted/" + Data?.lgd_dist_code;
    CommonAxiosGet(url).then((res) => {
      if (res.data.scode === "01") {
        setMappedMandals(res.data);
      }
    });
  }
  useEffect(() => {
    MandalsMappedData();
  }, []);
  return (
    <>
      <Header />
      <div className="main_section"> </div>
          <Container>
            <Row>
              <Col  xs={12} sm={12} md={12} lg={12} xl={12}  xxl={12} className="page-titlespacing d-flex justify-content-between" >
                <div className="inner-herbpage-service-title1">
                  <h1><span style={{color:"brown"}}> {Data?.distname}</span> - ALO Mapped Mandals Report</h1>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={()=>{navigate(-1)}}>
                    Back
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            <Row className="px-4">
              <Table className="table table-condensed table-bordered table-striped table-responsive tableex mt-3 mb-5" >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mandals Mapped</th>
                    <th>ALO Office</th>
                  </tr>
                </thead>
                <tbody>
                  {MappedMandals?.DATA &&
                    MappedMandals?.DATA?.map((data, i) => {
                      return (
                        <tr>
                          <td style={{ width: '380px', textAlign: "center" }}>{i + 1}</td>
                          <td style={{ textAlign: "center", width: "480px" }}>
                            {data.mandal_name}
                          </td>
                          <td style={{ width: '680px' }}>{data.org_name}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>

            </Row>

          </Container>
       
    </>
  );
}
